(function () {
  'use strict';

  function initReviewsSection(section) {
    if (!section) return;

    if (section.dataset.reviewsInitialized === 'true') {
      return;
    }

    var slider = section.querySelector('[data-reviews-slider]');
    var track = section.querySelector('[data-reviews-track]');
    var slides = Array.from(section.querySelectorAll('[data-review-slide]'));

    var prevButton = section.querySelector('[data-review-prev]');
    var nextButton = section.querySelector('[data-review-next]');
    var dots = Array.from(section.querySelectorAll('[data-review-dot]'));

    if (!slider || !track || !slides.length) {
      return;
    }

    section.dataset.reviewsInitialized = 'true';

    var currentIndex = 0;
    var totalSlides = slides.length;

    var isMouseDown = false;
    var mouseStartX = 0;
    var mouseMoved = false;

    var touchStartX = 0;
    var touchStartY = 0;

    var resizeTimer = null;

    /*
    |--------------------------------------------------------------------------
    | SLIDES PER VIEW
    |--------------------------------------------------------------------------
    */

    function getSlidesPerView() {
      return window.innerWidth <= 749 ? 1 : 3;
    }

    /*
    |--------------------------------------------------------------------------
    | MAX INDEX
    |--------------------------------------------------------------------------
    */

    function getMaxIndex() {
      var slidesPerView = getSlidesPerView();

      return Math.max(
        0,
        totalSlides - slidesPerView
      );
    }

    /*
    |--------------------------------------------------------------------------
    | GET GAP
    |--------------------------------------------------------------------------
    */

    function getGap() {
      return window.innerWidth <= 749 ? 0 : 24;
    }

    /*
    |--------------------------------------------------------------------------
    | SET SLIDE WIDTH
    |--------------------------------------------------------------------------
    */

    function updateSlideWidths() {
      var slidesPerView = getSlidesPerView();
      var gap = getGap();

      var sliderWidth = slider.clientWidth;

      if (!sliderWidth) return;

      var slideWidth =
        (sliderWidth - ((slidesPerView - 1) * gap)) /
        slidesPerView;

      slides.forEach(function (slide) {
        slide.style.flexBasis = slideWidth + 'px';
        slide.style.width = slideWidth + 'px';
      });
    }

    /*
    |--------------------------------------------------------------------------
    | ADAPTIVE HEIGHT
    |--------------------------------------------------------------------------
    */

    function updateAdaptiveHeight() {
      var slidesPerView = getSlidesPerView();

      /*
       * MOBILE
       * Only current slide height controls slider height.
       */
      if (slidesPerView === 1) {
        var currentSlide = slides[currentIndex];

        if (!currentSlide) return;

        var mobileHeight = currentSlide.offsetHeight;

        if (mobileHeight > 0) {
          slider.style.height = mobileHeight + 'px';
        }

        return;
      }

      /*
       * DESKTOP
       * Height is based on the tallest visible card.
       */
      var maxHeight = 0;

      var start = currentIndex;
      var end = Math.min(
        currentIndex + slidesPerView,
        totalSlides
      );

      for (var i = start; i < end; i++) {
        var slideHeight = slides[i].offsetHeight;

        if (slideHeight > maxHeight) {
          maxHeight = slideHeight;
        }
      }

      if (maxHeight > 0) {
        slider.style.height = maxHeight + 'px';
      }
    }

    /*
    |--------------------------------------------------------------------------
    | UPDATE POSITION
    |--------------------------------------------------------------------------
    */

    function updateSlider(animate) {
      var slidesPerView = getSlidesPerView();
      var maxIndex = getMaxIndex();

      if (currentIndex > maxIndex) {
        currentIndex = maxIndex;
      }

      if (currentIndex < 0) {
        currentIndex = 0;
      }

      updateSlideWidths();

      var gap = getGap();

      var sliderWidth = slider.clientWidth;

      if (!sliderWidth) return;

      var slideWidth =
        (sliderWidth - ((slidesPerView - 1) * gap)) /
        slidesPerView;

      var offset =
        currentIndex * (slideWidth + gap);

      track.style.transition = animate
        ? 'transform 0.45s cubic-bezier(0.4, 0, 0.2, 1)'
        : 'none';

      track.style.transform =
        'translate3d(-' + offset + 'px, 0, 0)';

      /*
       * Wait one frame so browser has updated
       * slide dimensions before measuring height.
       */
      requestAnimationFrame(function () {
        updateAdaptiveHeight();
      });

      /*
      |--------------------------------------------------------------------------
      | DOTS
      |--------------------------------------------------------------------------
      */

      dots.forEach(function (dot, index) {
        dot.classList.toggle(
          'is-active',
          index === currentIndex
        );
      });

      /*
      |--------------------------------------------------------------------------
      | BUTTONS
      |--------------------------------------------------------------------------
      */

      if (prevButton) {
        prevButton.classList.toggle(
          'is-disabled',
          currentIndex === 0
        );
      }

      if (nextButton) {
        nextButton.classList.toggle(
          'is-disabled',
          currentIndex >= maxIndex
        );
      }
    }

    /*
    |--------------------------------------------------------------------------
    | NEXT
    |--------------------------------------------------------------------------
    */

    function goNext() {
      var maxIndex = getMaxIndex();

      if (currentIndex >= maxIndex) {
        return;
      }

      currentIndex++;

      updateSlider(true);
    }

    /*
    |--------------------------------------------------------------------------
    | PREVIOUS
    |--------------------------------------------------------------------------
    */

    function goPrevious() {
      if (currentIndex <= 0) {
        return;
      }

      currentIndex--;

      updateSlider(true);
    }

    /*
    |--------------------------------------------------------------------------
    | BUTTON EVENTS
    |--------------------------------------------------------------------------
    */

    if (prevButton) {
      prevButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        goPrevious();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        goNext();
      });
    }

    /*
    |--------------------------------------------------------------------------
    | DOT EVENTS
    |--------------------------------------------------------------------------
    */

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var index = parseInt(
          dot.getAttribute('data-review-dot'),
          10
        );

        if (isNaN(index)) {
          return;
        }

        var maxIndex = getMaxIndex();

        currentIndex = Math.min(
          index,
          maxIndex
        );

        updateSlider(true);
      });
    });

    /*
    |--------------------------------------------------------------------------
    | MOBILE TOUCH SWIPE
    |--------------------------------------------------------------------------
    */

    slider.addEventListener(
      'touchstart',
      function (event) {
        if (!event.touches || !event.touches.length) {
          return;
        }

        touchStartX =
          event.touches[0].clientX;

        touchStartY =
          event.touches[0].clientY;
      },
      {
        passive: true
      }
    );

    slider.addEventListener(
      'touchend',
      function (event) {
        if (
          !event.changedTouches ||
          !event.changedTouches.length
        ) {
          return;
        }

        var touchEndX =
          event.changedTouches[0].clientX;

        var touchEndY =
          event.changedTouches[0].clientY;

        var distanceX =
          touchEndX - touchStartX;

        var distanceY =
          touchEndY - touchStartY;

        /*
         * Ignore vertical scrolling.
         */
        if (
          Math.abs(distanceX) < 40 ||
          Math.abs(distanceY) > Math.abs(distanceX)
        ) {
          return;
        }

        if (distanceX < 0) {
          goNext();
        } else {
          goPrevious();
        }
      },
      {
        passive: true
      }
    );

    /*
    |--------------------------------------------------------------------------
    | DESKTOP MOUSE DRAG
    |--------------------------------------------------------------------------
    */

    slider.addEventListener(
      'mousedown',
      function (event) {
        /*
         * Only left mouse button.
         */
        if (event.button !== 0) {
          return;
        }
        event.preventDefault();

        isMouseDown = true;
        mouseMoved = false;
        mouseStartX = event.clientX;

        track.classList.add('is-dragging');
      }
    );

    slider.addEventListener(
      'mousemove',
      function (event) {
        if (!isMouseDown) {
          return;
        }

        event.preventDefault();

        var distance =
          event.clientX - mouseStartX;

        if (Math.abs(distance) < 50) {
          return;
        }

        mouseMoved = true;
        isMouseDown = false;

        track.classList.remove('is-dragging');

        if (distance < 0) {
          goNext();
        } else {
          goPrevious();
        }
      }
    );

    function stopMouseDrag() {
      if (!isMouseDown) {
        return;
      }

      isMouseDown = false;

      track.classList.remove(
        'is-dragging'
      );
    }

    window.addEventListener(
      'mouseup',
      stopMouseDrag
    );

    slider.addEventListener(
      'mouseleave',
      stopMouseDrag
    );

    /*
    |--------------------------------------------------------------------------
    | PREVENT CLICK AFTER DRAG
    |--------------------------------------------------------------------------
    */

    slider.addEventListener(
      'click',
      function (event) {
        if (mouseMoved) {
          event.preventDefault();
          event.stopPropagation();

          mouseMoved = false;
        }
      },
      true
    );

    /*
    |--------------------------------------------------------------------------
    | IMAGE LOAD
    |--------------------------------------------------------------------------
    */

    var images = slider.querySelectorAll('img');

    images.forEach(function (image) {
      if (!image.complete) {
        image.addEventListener(
          'load',
          function () {
            updateSlideWidths();
            updateAdaptiveHeight();
          }
        );
      }
    });

    /*
    |--------------------------------------------------------------------------
    | RESIZE
    |--------------------------------------------------------------------------
    */

    window.addEventListener(
      'resize',
      function () {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(
          function () {
            updateSlider(false);
          },
          100
        );
      }
    );

    /*
    |--------------------------------------------------------------------------
    | RESIZE OBSERVER
    |--------------------------------------------------------------------------
    */

    if (
      typeof ResizeObserver !== 'undefined'
    ) {
      var resizeObserver =
        new ResizeObserver(function () {
          updateSlideWidths();
          updateAdaptiveHeight();
        });

      resizeObserver.observe(slider);

      slides.forEach(function (slide) {
        resizeObserver.observe(slide);
      });
    }

    /*
    |--------------------------------------------------------------------------
    | INITIAL
    |--------------------------------------------------------------------------
    */

    updateSlider(false);

    /*
     * Second measurement after browser
     * has completed layout.
     */
    requestAnimationFrame(function () {
      updateSlideWidths();
      updateAdaptiveHeight();
    });

    setTimeout(function () {
      updateSlideWidths();
      updateAdaptiveHeight();
    }, 250);
  }

  /*
  |--------------------------------------------------------------------------
  | INIT ALL
  |--------------------------------------------------------------------------
  */

  function initAllReviewsSections() {
    var sections = document.querySelectorAll(
      '.reviews-same-story'
    );

    sections.forEach(function (section) {
      initReviewsSection(section);
    });
  }

  /*
  |--------------------------------------------------------------------------
  | DOCUMENT READY
  |--------------------------------------------------------------------------
  */

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initAllReviewsSections
    );
  } else {
    initAllReviewsSections();
  }

  /*
  |--------------------------------------------------------------------------
  | SHOPIFY THEME EDITOR
  |--------------------------------------------------------------------------
  */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      if (
        !event.detail ||
        !event.detail.sectionId
      ) {
        return;
      }

      var section =
        document.getElementById(
          'shopify-section-' +
          event.detail.sectionId
        );

      if (!section) {
        return;
      }

      var reviews =
        section.querySelector(
          '.reviews-same-story'
        );

      if (!reviews) {
        return;
      }

      reviews.dataset.reviewsInitialized =
        'false';

      initReviewsSection(reviews);
    }
  );
})();